import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
// import circularIcon from "../../assets/images/partnerDashboard/logo/circularIcon.png"
import BNRathiLogoSide from "../../assets/images/BNRathiLogoSide.png";
import { useNavigate } from "react-router-dom";

const EsignConfirmationModal = ({ showModal, onCloseClick }) => {
  const navigate = useNavigate();
  return (
    <Modal isOpen={showModal?.show} toggle={onCloseClick} centered={true}>
      <ModalHeader toggle={onCloseClick}>E-Sign Required</ModalHeader>
      <ModalBody className="">
        <div className="mt-2 text-start">
          <p className="fs-p-bg text-muted text-start">
            *Note: Setting bank preference as Primary requires E-Sign
            Verification.
          </p>
          <p className=" fs-p-bg text-muted text-start">
          Setting bank preference as Primary requires E-Sign In Verification. Setting bank preference as Primary requires E-Sign In Verification. Setting bank preference as Primary requires E-Sign In Verification. Setting bank preference as Primary requires E-Sign In Verification. Setting bank preference as Primary requires E-Sign In Verification. 
          </p>
        </div>

        <div className="d-flex gap-2 justify-content-center mt-4 mb-0">
          <button
            type="button"
            className="btn w-sm btn-primary"
            data-bs-dismiss="modal"
            onClick={() => {
              // navigate("/login");
              // console.log("here");
            }}
          >
            Continue to E-Sign
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default EsignConfirmationModal;
